// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"bv-z","slideIn":"cv-z"};